import React from 'react'
import * as yup from 'yup'
import { useContext, useState } from 'react'
import { useFormik } from 'formik'
import { useApiCall } from '../../../custom-hooks/api-call'
import "react-datepicker/dist/react-datepicker.css";
import { Alert, Snackbar } from '@mui/material'
import { FormArea, FeildWraper, SelectSearch, FeildError, FormLabel } from '../../../form/form-layout'
import { GlobalContext } from '../../../../context/Context';
import moment from 'moment'

const AddUpdatePPC = ({ Style, data, onClose = () => { }, onChange = () => { }, onSuccess = () => { }, onError = () => { } }) => {
    const apiCall = useApiCall();
    let { state } = useContext(GlobalContext);

    const validationSchema = yup.object().shape({
        date: yup.string().required('This Field is required'),
        brand: yup.string().required('This Field is required'),
        service: yup.string().required('This Field is required'),
        device: yup.string().required('This Field is required'),
        platform: yup.string().required('This Field is required'),    
    });

    const formik = useFormik({
        initialValues: {
            date: data?.date ? moment(data?.date, "DD-MMM-YYYY").format("YYYY-MM-DD") : "",
            service: data?.service_id ?? "",
            platform: data?.platform_id ?? "",
            brand: data?.brand_id ?? "",
            device: data?.device ?? "",
            clicks: data?.clicks ?? "",
            impressions: data?.impressions ?? "",
            ad_spend: data?.ad_spend ? data?.ad_spend?.replaceAll("$", "") : "",
            conversions: data?.conversions ?? "",
            revenue: data?.revenue ? data?.revenue?.replaceAll("$", "") : "",
            leads: data?.leads ?? "",
            upsell: data?.total_upsell ? data?.total_upsell?.replaceAll("$", "") : "",
            operation: data?.operation_by_id ?? "",
            niche_id: data?.niche_id ?? ""
        },
        // enableReinitialize: true,
        validationSchema,
        onSubmit: async (values) => {
            let extraField = {}
            if (data) {extraField = {"ppc_id": data?.id}}

            // Perform API POST here
            let apiData = JSON.stringify({
                ...extraField,
                "date": values.date,
                "service_id": values.service,
                "platform_id": values.platform,
                "brand_id": values.brand,
                "device": values.device,
                "clicks": values.clicks,
                "impressions": values.impressions,
                "ad_spend": values.ad_spend,
                "conversions": values.conversions,
                "revenue": values.revenue,
                "leads": values.leads,
                "total_upsell": values.upsell,
                "operation_by": (state.user.mainRole == "admin" || state.user.employee_role == "5" || state.user.employee_role == "6") ? values.operation ?? "" : state.user?.employee_id,
                "niche_id": values?.niche_id
            });

            try {
                const apiRes = await apiCall({ method: "post", url: (data?.id) ? "update-ppc-data" : "store-ppc-data", data: apiData })
                onSuccess(apiRes.message || "PPC Added")
                onChange()
                onClose();
                formik.resetForm();
            } catch (error) {
                onError(error?.response.data?.respMsg || error?.response.data?.responseMessage || error?.response.data?.message || "Some Thing Went Wrong")
                console.warn("Error : ", error)
            }
        }
    });

    return (
        <>
            <form onSubmit={formik.handleSubmit} className={Style.modal_main}>
                <div className={Style.modal_body}>
                    <FormArea>
                        <FeildWraper>
                            <FormLabel required>Date</FormLabel>
                            <input
                                type={'date'}
                                name={'date'}
                                onChange={formik.handleChange}
                                value={formik.values.date}
                                placeholder='date'
                            />
                            {formik.touched.date && formik.errors.date && (
                                <FeildError>{formik.errors.date}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Brand</FormLabel>
                            <SelectSearch
                                name="brand"
                                placeholder='- Select Brand -'
                                onChange={(val) => {
                                    formik.setFieldValue("brand", val);
                                }}
                                value={formik.values.brand}
                                options={state?.getDropdowns?.brandList.map((el) => ({
                                    label: el.name,
                                    value: el.id,
                                }))}
                            />
                            {formik.touched.brand && formik.errors.brand && (
                                <FeildError>{formik.errors.brand}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Service</FormLabel>
                            <SelectSearch
                                name="service"
                                placeholder='- Select Service -'
                                onChange={(val) => {
                                    formik.setFieldValue("service", val);
                                }}
                                value={formik.values.service}
                                options={state?.getDropdowns?.serviceList.map((el) => ({
                                    label: el.name,
                                    value: el.id,
                                }))}
                            />
                            {formik.touched.service && formik.errors.service && (
                                <FeildError>{formik.errors.service}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel>Niche</FormLabel>
                            <SelectSearch
                                name="niche_id"
                                placeholder='- Select Niche -'
                                onChange={(val) => {
                                    formik.setFieldValue("niche_id", val);
                                }}
                                value={formik.values.niche_id}
                                options={state?.getDropdowns?.nicheList?.map((el) => ({
                                    label: el.name,
                                    value: el.id,
                                }))}
                            />
                            {/* {formik.touched.niche_id && formik.errors.niche_id && (
                                <FeildError>{formik.errors.niche_id}</FeildError>
                            )} */}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Device</FormLabel>
                            <SelectSearch
                                name="device"
                                placeholder='- Select Device -'
                                onChange={(val) => {
                                    formik.setFieldValue("device", val);
                                }}
                                value={formik.values.device}
                                options={[{ label: "Desktop", value: "Desktop" }, { label: "Mobile", value: "Mobile" }]}
                            />
                            {formik.touched.device && formik.errors.device && (
                                <FeildError>{formik.errors.device}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Platform</FormLabel>
                            <SelectSearch
                                name="platform"
                                placeholder='- Select Platform -'
                                onChange={(val) => {
                                    formik.setFieldValue("platform", val);
                                }}
                                value={formik.values.platform}
                                options={state?.getDropdowns?.platforms.map((el) => ({
                                    label: el.name,
                                    value: el.id,
                                }))}
                            />
                            {formik.touched.platform && formik.errors.platform && (
                                <FeildError>{formik.errors.platform}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel>Clicks</FormLabel>
                            <input
                                type={'number'}
                                name={'clicks'}
                                onChange={formik.handleChange}
                                value={formik.values.clicks}
                                placeholder='clicks'
                            />
                            {/* {formik.touched.clicks && formik.errors.clicks && (
                                <FeildError>{formik.errors.clicks}</FeildError>
                            )} */}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel>Impressions</FormLabel>
                            <input
                                type={'number'}
                                name={'impressions'}
                                onChange={formik.handleChange}
                                value={formik.values.impressions}
                                placeholder='impressions'
                            />
                            {/* {formik.touched.impressions && formik.errors.impressions && (
                                <FeildError>{formik.errors.impressions}</FeildError>
                            )} */}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel>Ad Spend</FormLabel>
                            <input
                                type={'number'}
                                name={'ad_spend'}
                                onChange={formik.handleChange}
                                value={formik.values.ad_spend}
                                placeholder='ad_spend'
                            />
                            {/* {formik.touched.ad_spend && formik.errors.ad_spend && (
                                <FeildError>{formik.errors.ad_spend}</FeildError>
                            )} */}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel >Conversions</FormLabel>
                            <input
                                type={'number'}
                                name={'conversions'}
                                onChange={formik.handleChange}
                                value={formik.values.conversions}
                                placeholder='conversions'
                            />
                            {/* {formik.touched.conversions && formik.errors.conversions && (
                                <FeildError>{formik.errors.conversions}</FeildError>
                            )} */}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel>Revenue</FormLabel>
                            <input
                                type={'number'}
                                name={'revenue'}
                                onChange={formik.handleChange}
                                value={formik.values.revenue}
                                placeholder='revenue'
                            />
                            {/* {formik.touched.revenue && formik.errors.revenue && (
                                <FeildError>{formik.errors.revenue}</FeildError>
                            )} */}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel >Leads</FormLabel>
                            <input
                                type={'number'}
                                name={'leads'}
                                onChange={formik.handleChange}
                                value={formik.values.leads}
                                placeholder='leads'
                            />
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel>Total Upsell</FormLabel>
                            <input
                                type={'number'}
                                name={'upsell'}
                                onChange={formik.handleChange}
                                value={formik.values.upsell}
                                placeholder='upsell'
                            />
                        </FeildWraper>

                        {(state.user.mainRole == "admin" || state.user.employee_role == "5" || state.user.employee_role == "6") ?
                            <FeildWraper>
                                <FormLabel required>Operation By</FormLabel>
                                <SelectSearch
                                    name="operation"
                                    placeholder='- Select User -'
                                    onChange={(val) => {
                                        // getDeptUsersList(val);
                                        formik.setFieldValue("operation", val);
                                    }}
                                    value={formik.values.operation}
                                    menuPlacement='top'
                                    options={state.getDropdowns?.marketingMembers.map((el) => ({
                                        label: el.employee_name,
                                        value: el.employee_id,
                                    }))}
                                    isDisabled={!state.getDropdowns?.marketingMembers?.length}
                                />
                                {formik.touched.operation && formik.errors.operation && (
                                    <FeildError>{formik.errors.operation}</FeildError>
                                )}
                            </FeildWraper>
                            :
                            null
                        }
                    </FormArea>
                </div>

                <div className={Style.modal_foot}>
                    <div className={`${Style.dcmb__cancel} opacity-0 pointer-events-none cursor-default`}>Cancel</div>
                    <button type="submit" className={Style.dcmb__submit}>Submit</button>
                </div>
            </form>
        </>
    )
}

export default AddUpdatePPC
